module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_Black_MockedUp.893bb2c1.jpg";